<template>
  <div class="spl-header-holder">
    <header class="spl-header">
      <div :class="{'spl-header__logo': config.is_Prod_Env(), 'spl-header__dev-logo': !config.is_Prod_Env()}" />
      <input
        id="spl-header__menu"
        class="spl-header__open-menu"
        type="checkbox">
      <div class="spl-header__burger">
        <label class="spl-header__menu-icon" for="spl-header__menu"><span /></label>
      </div>
      <div class="spl-header__nav">
        <router-link
          v-if="userHasPermission(constants.PERMISSION_TYPES.DASHBOARD, constants.PERMISSION_VALUES.VIEW)"
          to="/dashboard"
          tag="div"
          class="spl-header__nav__item"
          active-class="spl-header__nav__item-active">
          Dashboard
        </router-link>
        <router-link
          v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.LIST)"
          to="/parcel-list"
          tag="div"
          class="spl-header__nav__item"
          active-class="spl-header__nav__item-active">
          Parcel List
        </router-link>
        <div
          v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.REPORT, constants.PERMISSION_VALUES.LIST)"
          class="spl-header__nav__item">
          Report
          <div class="spl-header__nav__item__submenu-holder">
            <ul class="spl-header__nav__item__submenu">
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.REPORT, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/report-list">
                  Report List
                </router-link>
              </li>
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.DROP_COST, constants.PERMISSION_VALUES.VIEW)" class="spl-header__nav__item__submenu__item">
                <router-link to="/drop-cost-report">
                  Drop Cost
                </router-link>
              </li>
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.EXPORT_PROOF, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/export-proof-list">
                  Export Proof List
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.PUDO_EXPIRY, constants.PERMISSION_VALUES.LIST)"
          class="spl-header__nav__item">
          Expiry
          <div class="spl-header__nav__item__submenu-holder">
            <ul class="spl-header__nav__item__submenu">
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.PUDO_EXPIRY, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/expiry-manager">
                  Expiry Manager
                </router-link>
              </li>
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.PUDO_EXPIRY, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/expiry-history">
                  Expiry History
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <router-link
          v-if="userHasPermission(constants.PERMISSION_TYPES.MATCH_SCAN, constants.PERMISSION_VALUES.CREATE)"
          to="/match-scan"
          tag="div"
          class="spl-header__nav__item"
          active-class="spl-header__nav__item-active">
          Match Scan
        </router-link>
        <router-link
          v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT_MEASURE, constants.PERMISSION_VALUES.LIST)"
          to="/problem-report-measures"
          tag="div"
          class="spl-header__nav__item"
          active-class="spl-header__nav__item-active">
          Measures
        </router-link>
        <div v-if="userHasSubmenuPermission()" class="spl-header__nav__item">
          <img src="../../assets/plane-car.svg">
          <div class="spl-header__nav__item__submenu-holder">
            <ul class="spl-header__nav__item__submenu">
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.DAILY_CARGO, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/precarriage-list">
                  PreCarriage
                </router-link>
              </li>
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.DAILY_CARGO, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/daily-cargo-general">
                  Daily Cargo
                </router-link>
              </li>
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.DAILY_CARGO, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/linehaul-road-list">
                  Linehaul Road
                </router-link>
              </li>
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.DAILY_CARGO, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/adhoc-drive-list">
                  Adhoc Drive
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="userHasSubmenuPermission()" class="spl-header__nav__item">
          <img src="../../assets/icon-book-parcel.svg">
          <div class="spl-header__nav__item__submenu-holder">
            <ul class="spl-header__nav__item__submenu">
              <li v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK)" class="spl-header__nav__item__submenu__item">
                <router-link to="/parcel-book">
                  Book Parcel
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK_CONSOLIDATED)" class="spl-header__nav__item__submenu__item">
                <router-link to="/consolidated-book">
                  Book Consolidated
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK_WITH_FILE)" class="spl-header__nav__item__submenu__item">
                <router-link to="/book-with-file">
                  Book with File
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK_WITH_FILE)" class="spl-header__nav__item__submenu__item">
                <router-link to="/update-with-file">
                  Update with File
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.SCAN_WITH_FILE)" class="spl-header__nav__item__submenu__item">
                <router-link to="/scan-with-file">
                  Scan with File
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="userHasSubmenuPermission()" class="spl-header__nav__item">
          <img src="../../assets/cog-outline.svg">
          <div class="spl-header__nav__item__submenu-holder">
            <ul class="spl-header__nav__item__submenu">

              <li v-if="userHasPermission(constants.PERMISSION_TYPES.DEADLINE, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link
                  to="/deadline-list">
                  Deadlines
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.USER, constants.PERMISSION_VALUES.CREATE)" class="spl-header__nav__item__submenu__item">
                <router-link to="/admin/create-user">
                  Create new user
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.USER, constants.PERMISSION_VALUES.CREATE)" class="spl-header__nav__item__submenu__item">
                <router-link to="/admin/create-user-by-file">
                  Create new user by file
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.USER, constants.PERMISSION_VALUES.LIST)" class="spl-header__nav__item__submenu__item">
                <router-link to="/admin/user-list">
                  Manage Users
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="spl-header__nav__item">
          <img src="../../assets/icon-profile.svg">
          <div class="spl-header__nav__item__submenu-holder">
            <ul class="spl-header__nav__item__submenu">
              <li class="spl-header__nav__item__submenu__item">
                <router-link to="/admin/personal-settings">
                  Personal Settings
                </router-link>
              </li>
              <li v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.SPLIT_NEWS, constants.PERMISSION_VALUES.CREATE)" class="spl-header__nav__item__submenu__item">
                <router-link to="/admin/maintain-internal-news">
                  Maintain Internal News
                </router-link>
              </li>
              <li class="spl-header__nav__item__submenu__item" @click="onLogoutClicked">
                Logout
              </li>
            </ul>
          </div>
        </div>

        <dotmatrixstatus
          v-if="false && dashboardData"
          :dashboard-data="dashboardData"
          :filter-setting="filterSetting" />
        <!-- *********************** Migration Error button *********************************** -->
        <div
          v-if="$mq !== 'sm' && userHasPermission(constants.PERMISSION_TYPES.MONITORING, constants.PERMISSION_VALUES.VIEW)"
          class="spl-header__latest-updates spl-header__nav__item">
          <item-migration-error-list class="item-migration-error-list" />
        </div>
      </div>
      <div class="spl-header__search">
        <form-input
          v-model="searchTerm"
          class="spl-header__search__input"
          placeholder="Search..."
          @enterPressed="handleSearch" />
        <button
          v-if="!searchActive"
          class="spl-header__search__icon-button spl-header__search__button"
          @click="handleSearch">
          <img src="../../assets/icon-search.svg">
        </button>
        <button
          v-if="searchActive"
          class="spl-header__search__icon-button spl-header__search__cancel"
          @click="cancelSearch">
          <img src="../../assets/icon-close.svg">
        </button>
      </div>
    </header>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import constants from '@/constants'
import { mapActions, mapState, mapGetters } from 'vuex'
import config from '@/config'

export default {
  name: 'MainHeader',
  mixins: [Helpers],
  props: {
    dashboardData: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    },

    viewMode: {
      type: String,
      default: 'Precarriage',
      required: false
    },

    filterSetting: {
      type: Object,
      required: false,
      default: function () {
        return {
          From_Date: '',
          To_Date: '',
          Customers: [],
          Countries: [],
          Parcel_Status: [],
          Service_Levels: [],
          Current_Event_Infos: [],
          Show_Forward_Flow: true
        }
      }
    }
  },
  data () {
    return {
      notCompleted: 133,
      critical: 52,
      ok: 1200,
      total: 1385,
      currentDate: '',
      searchTerm: '',
      constants,
      config
    }
  },
  computed: {
    ...mapState('news', ['news']),
    ...mapGetters('news', ['newNewsCount']),
    searchActive () {
      return this.$route.query.search !== undefined
    }
  },
  watch: {
    dashboardData: function (newDashboardSummary) {
      this.dashboardData = newDashboardSummary
    },
    viewMode: function (newValue) {
      this.viewMode = newValue
    }
  },
  mounted () {
    if (this.$route.query.search) {
      this.searchTerm = this.$route.query.search
    }
    this.currentDate = this.formatDate(new Date(), true, 'dddd, MMMM Do YYYY')
  },
  methods: {
    ...mapActions('auth', ['logout']),
    // Show the full news
    show_Full_News (news) {
      var newsModal = '<b>' + news.Title + '</b> - ' + news.News_Date + '<br><br>' + news.Body
      window.bus.$emit('openInfoModal', newsModal)
    },

    handleSearch () {
      this.$router.push('/parcel-list?search=' + encodeURIComponent(this.searchTerm))
      this.$emit('onSearch', this.searchTerm)
      this.$forceUpdate()
    },
    cancelSearch () {
      this.$router.push('/parcel-list')
      this.searchTerm = ''
      this.$emit('onSearchCancel', this.searchTerm)
    },

    /// Logout from the page. Remove the token in auth and go to the login page.
    onLogoutClicked () {
      this.logout()
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";

.spl-header-holder {
  height: $headerHeight;
  width: 100%;

  .spl-header {
    &__burger, &__open-menu {
      display: none;
    }
    background-color: $mainInputColor;
    height: $headerHeight;
    position: fixed;
    display: inline-flex;
    top: 0;
    width: 100%;
    z-index: 9000;

    &:after {
      clear: both;
      content: "";
      display: block;
      float: none;
    }
    &__logo {
      background-image: url(../../assets/logo.png);
      background-position: 20px center;
      background-repeat: no-repeat;
      height: $headerHeight;
      width: 180px;
      @media (max-width: 1000px) {
        display: none;
      }
    }
    &__dev-logo {
      background-image: url(../../assets/logo-dev.png);
      background-position: 20px center;
      background-repeat: no-repeat;
      height: $headerHeight;
      width: 180px;
      @media (max-width: 1000px) {
        display: none;
      }
    }
    &__nav {
      display: inline-flex;
      height: $headerHeight;

      &:after {
        clear: both;
        content: "";
        display: block;
        float: none;
      }
      &__item {
        border-right: 1px solid $headerNavBorderColor;
        color: $disabledYellow;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
        height: $headerHeight;
        line-height: $headerHeight + 2px;
        min-width: 70px;
        padding: 0 15px;
        position: relative;
        transition: all $shortTransition ease-in-out;

        &:first-child {
          border-left: 1px solid $headerNavBorderColor;
        }
        &:hover,
        &-active {
          background-color: rgba($yellowButtonLabelHover, 0.5);
          border-color: transparent;
          color: $headerNavHoverColor;
        }
        &:hover {
          .spl-header__nav__item__submenu-holder {
            z-index: 9000;
            opacity: 1;
            pointer-events: auto;
          }
        }
        img {
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
        &__submenu-holder {
          left: 50%;
          opacity: 0;
          pointer-events: none;
          padding-top: 20px;
          position: absolute;
          top: 50px;
          transform: translate3d(-50%, 0, 0);
          transition: all $shortTransition ease-in-out;
        }
        &__submenu {
          background-color: $mainTextColor;
          box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.5);
          padding: 15px 90px 20px 25px;
          position: relative;

          &:before {
            border-color: transparent transparent $mainTextColor transparent;
            border-style: solid;
            border-width: 0 9px 8px 9px;
            content: "";
            display: block;
            height: 0;
            left: calc(50% - 9px);
            position: absolute;
            top: -8px;
            width: 0;
          }
          &__item {
            line-height: 24px;
            list-style-type: none;

            a {
              color: $disabledYellow;
              font-size: 14px;
              transition: color $shortTransition ease-in-out;
              text-decoration: none;
              white-space: nowrap;
            }
            &:hover a {
              color: $headerNavHoverColor;
            }
          }
        }
      }
    }
    &__latest-updates {
      border-left: 1px solid $headerNavBorderColor;
      color: $headerNavHoverColor;
      float: right;
      font-family: $mono;
      font-size: 9px;
      font-weight: 700;
      height: $headerHeight;
      letter-spacing: 1px;
      line-height: 12px;
      padding: 20px 10px 20px 20px;
      text-transform: uppercase;
      width: 130px;

      &__badge {
        color: $headerLatestUpdatesBadgeColor;
      }
      @media screen and (max-width: 1200px) {
        display: none
      }
    }

    &__search {
      &__input {
        width: 200px;
      }
      position: absolute;
      right: 15px;
      top: 15px;
      display: flex;
      &__icon-button {
        cursor: pointer;
        background: $grey_20;
        border: 0;
        height: 41px;
        width: 46px;
        border-radius: 5px;
        &:focus {
          background-color: #222;
        }
        &:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }

      &__button {
        margin-left: 10px;
      }
      &__cancel {
        margin-left: 10px;
        background-color: #962133;
      }
    }
  }
  @include mobile() {
    .spl-header {
       &__search {
        width: calc(100% - 64px);
        justify-content: space-around;
        align-items: stretch;
         &__input {
           width: auto;
           min-width: 10px;
           flex-grow: 1;
         }
         &__icon-button {
           min-width: 46px;
           max-width: 46px;
           width: auto;
         }
       }
      height: auto;
      position: fixed;
      display: inline;
      background-color: transparent;
      &__burger {
        width: 100%;
        background-color: black;
        height: $headerHeight;
        display: block;
      }
      &__logo {
        display: none;
      }

      &__open-menu {
        display: block;
        z-index: 10000;
        display:none;
        &:checked {
          & ~ div .spl-header__menu-icon span {
            background: transparent;
            &:before {
              transform: rotate(-45deg);
            }
            &:after {
              transform: rotate(45deg);
            }
            &:after, &:before {
              top: 0
            }
          }
          & ~ .spl-header__nav {
            display: inline;
            opacity: 1;
          }
        }
      }

      &__menu-icon {
        z-index: 10000;
        cursor: pointer;
        left: 10px;
        top: 13px;
        padding: 41px 48px;
        position: relative;
        user-select: none;
        & span {
          background: #FFF;
          display: block;
          height: 3px;
          position: relative;
          transition: background .2s ease-out;
          width: 22px;
        }

        & span:before,
        & span:after {
          background: #FFF;
          content: '';
          display: block;
          height: 100%;
          position: absolute;
          transition: all .2s ease-out;
          width: 100%;
        }

        & span:before {
          top: 6px;
        }

        & span:after {
          top: -6px;
        }
      }

      &__latest-updates {
        display: none;
      }

      &__nav {
        display: none;
        float: none;
        opacity: 0;
        transition: opacity .2s ease-in-out;

        &__item:hover,
        &__item-active {
          background-color: $mainTextColor;
        }

        &__item {
          border-right: 1px solid $headerNavBorderColor;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          height: auto;
          line-height: normal;
          min-width: auto;
          padding: 10px;
          display: block;
          position: static;
          width: 100%;
          background-color: $mainTextColor;

          &:first-child {
            border-left: 0;
          }

          &-active {
            background-color: $grey_20;
            border: 0;
            color: $headerNavHoverColor;
          }

          img {
            display: none;
          }

          &__submenu-holder {
            left: 0;
            opacity: 1;
            pointer-events: auto;
            padding-top: 0px;
            position: static;
            top: 0;
            transform: none;
            transition: all $shortTransition ease-in-out;
          }
          &__submenu {
            margin: 0;
            background-color: $mainTextColor;
            box-shadow: none;
            padding: 0;
            position: inline;

            &:before {
              border-width: 0;
              content: none;
              display: none;
              height: 0;
              left: 0;
              position: static;
              top: 0;
              width: 0;
            }
            &__item {
              line-height: 24px;
              list-style-type: none;

              a {
                color: $disabledYellow;
                font-size: 14px;
                transition: color $shortTransition ease-in-out;
                text-decoration: none;
                white-space: nowrap;
              }
              &:hover a {
                color: $headerNavHoverColor;
              }
            }
          }
        }
      }

    }
  }
}
</style>
